<mat-dialog-content style="max-height: 60vw;max-width: 60vw;">
  <div id="w3l-appointment">
  <section class="w3l-form-25">
    <div class="form-inner-cont">
          <h1>{{'Decisions/Next steps' | translate }}</h1>
    </div>

<div class="styled-input">
  <div class="accounts" style="left: 50px;">
    <div class="appointment-form-field">
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

      <label style="font-size: large;font-weight: bold;left: 50px;">{{patientcode}}</label>
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
      <label style="font-size: large;font-weight: bold;left: 190px;">{{patientname}}</label>
    </div>
    <ul>
      <label style="font-size: large;font-weight: bold;left: 150px;">     </label>

      <label style="font-size: large;font-weight: bold;">Date :{{decdate}}</label>
      <label style="font-size: large;font-weight: bold;">     </label>
      <label style="font-size: large;font-weight: bold;">Time : {{dectime}}</label>
    </ul>
  </div>
  <mat-divider></mat-divider>

  <div class="appointment-form-field">
    <label style = "width: 20%;">Date </label>
    <input type="date" name="site" [(ngModel)]="decdate" style="width: 20%;" required="" />
    <label style = "width: 20%;"></label>
    <label style = "width: 15%;">Location </label>
    <select id="location" name="location"   [(ngModel)]="declocation" style="width: 33.5%;background-color:  rgb(187, 203, 238);"  required>
        <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
    </select>
  </div>
</div>

<mat-tab-group animationDuration="2000ms" style="width: 1500px;">
  <!----***************Diomgraphic*********************--->
  <mat-tab label="Decision/Next steps">

<div class="appointment-form-field" style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 40vh;">
<!-- <textarea id="myEditor" [(ngModel)]="decnotes" class="appointment-form-field" wrap="hard" style="width: 600px;height: 600px;">Start typing here...</textarea> -->
<angular-editor  [config]="editorConfigNoToolbar"  [placeholder]="'Enter text here...'" [(ngModel)]="decnotes" (ngModelChange)="updatePlainText()"></angular-editor>

</div>
</mat-tab>

  <mat-tab label="Requested Investigation/ Prescription" style="height: 585px !important;">
    <label class="appointment-form-field" style="background-color:  rgb(70, 70, 247);color: white; width: 820px;height: 10%;">Home Prescription</label>
      <!--******************** Select the treatment Group   **************************************-->
      <div class="styled-input appointment-form-field">
          <label>Treatment Group </label>
          <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="TreatmentGroupSearch()"></span>
          <input type="text" name="tgcode" placeholder="Group Code" style="width: 20%;border-width: 0.5px;" [(ngModel)]="tgcode" (change)=" retriveTreatmentGroupHD()">
          <input type="text" name="groupName" disabled style="width: 50%;background-color:  rgb(187, 203, 238);" [(ngModel)]="tgname">
     </div>
      <!--***************************************************************************************-->
    <table style="width: 820px;">
      <thead>
          <tr>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 29%;height: 20%;">Drug</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 29%;height: 20%;">Notes</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 7%;height: 10%;">Dose</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 7%;">Unit</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 20%;height: 10%;">Frequency</th>
              <th style="background-color:  rgb(70, 70, 247);color: white; width: 10%;height: 5%;">Select</th>
          </tr>
      </thead>
      <tbody>

        <tr *ngFor="let cur of currentmedication; let i = index" style="height: 50%;">
          <td data-column="Patient ID" style="height: 5%;">{{cur.ittname}}</td>
          <td data-column="Patient ID" style="height: 5%;">{{cur.duration}}</td>
          <td data-column="Patient Name"style="height: 30%;">{{cur.dose}}</td>
          <td data-column="Patient Name"style="height: 10%;">{{cur.unname}}</td>
          <td data-column="Patient Name"style="height: 10%;">{{cur.route}}</td>

          <button name="BDrug" placeholder = "0" style="width: 100%;height: 35px;" required (click)="SelectCurrent(cur)">Select</button>
        </tr>
      </tbody>
    </table>
    <div class="styled-input">
        <div class="appointment-form-field" style="width: 820px;">
         <select id="relation" name="relation" style="width: 29%;background-color:  rgb(187, 203, 238);" [(ngModel)]= "drugref" required>
            <option value="" >Select*</option>  
            <option value="{{itm2.itCode}}"  *ngFor="let itm2 of itemsList2; let i = index">{{itm2.itTName}}</option>
        </select>
        <input type="textarea" name="duration" placeholder="notes" [(ngModel)]= "duration" required="" style="width: 29%;"/>
        <input type="textarea" name="dos" placeholder="0" [(ngModel)]= "dose" required="" style="width: 7%;"/>
        <select id="department" name="unit" required="" style="width: 10%;background-color: white;" [(ngModel)]="uom" [value]="uom">
            <option value="{{unit.unCode}}" *ngFor="let unit of unitsList; let i = index">{{unit.unName}}</option>
        </select>
        <select id="solution" name="solution" required="" style="width:20%;background-color: white;" [(ngModel)]="route" >
            <option value="مره واحده صباحا">مره واحده صباحا</option>
            <option value="كل ١٢ ساعة(مرتين)">كل ١٢ ساعة(مرتين)</option>
            <option value="كل ٨ ساعات (ثلاث مرات)">كل ٨ ساعات (ثلاث مرات)</option>
            <option value="كل ٦ ساعات (اربع مرات)">كل ٦ ساعات (اربع مرات)</option>
        </select>
          <button class="fa fa-floppy-o" name="BDrug" placeholder = "0" style="width: 5%;height: 100%;color: rgb(0, 0, 145); " required (click)="submitCMedication()"></button>
          <button class="fa fa-trash" name="BDrug1" placeholder = "0" style="width: 5%;height: 100%;color: rgb(116, 2, 2);" required (click)="delCurrentMedication_Line()"></button>
        </div>
    </div>
<!-- 
    <label class="appointment-form-field" style="background-color:  rgb(70, 70, 247);color: white; width: 800px;height: 10%;">Requested Labs</label>
    <br>

      <div class="appointment-form-field" style="align-content: center;align-items: center;width: 800px;align-self: center;left: 20%;">
        <span class="fa fa-search-plus" aria-hidden="true" style="height: 200%;cursor: zoom-in;"  title="Zoom In"></span>
        <textarea rows = "15" cols = "60" name = "prognosis" [(ngModel)]= "invdescription" class="appointment-form-field" wrap="hard"  style="height: 200%;width: 750px;" (keyup)="limitLineLength()"> Enter details here... </textarea><br>
        <span class="fa fa-print" aria-hidden="true" style="height: 200%;cursor: grab;" (click)="Print_ReqLabDialog()" title="Print"></span>
      </div>
      <br>
      <label class="appointment-form-field" style="background-color:  rgb(70, 70, 247);color: white; width: 800px;height: 10%;">Requested Scan</label>
      <br>
      <div class="appointment-form-field" style="align-content: center;align-items: center;width: 800px;align-self: center;left: 20%;">
          <span class="fa fa-search-plus" aria-hidden="true" style="height: 200%;cursor: zoom-in;"  title="Zoom In"></span>
          <textarea rows = "15" cols = "60" name = "scandescription" [(ngModel)]= "scandescription" class="appointment-form-field" wrap="hard"  style="height: 200%;width: 750px;" (keyup)="limitLineLength()"> Enter details here... </textarea><br>
          <span class="fa fa-print" aria-hidden="true" style="height: 200%;cursor: grab;"  (click)="Print_ReqScanDialog()" title="Print"></span>

        </div> -->
  </mat-tab>

</mat-tab-group>
</section>
</div>
<BR>
<BR>

<mat-divider></mat-divider>
<BR>

<form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="Save_Data()" >{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="print" (click)="Print_PrescriptionDialog()">{{ 'Print Prescription' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 20%;height: 60px;font-weight: bold;background-color: rgb(123, 0, 0);color: white;border-style: none;height: 60%;" name="Back" (click)="Exit_Data()">{{ 'Exit' | translate }}</button>

    <label style="width: 25%;"></label>
</form>



